// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedBackgroundPanel__container-ecfd0a {
  width: 360px;
  background-color: var(--addition-100);
  overflow: hidden;
  height: calc(100% - 16px);
  margin: 8px 8px 8px 0;
  border-radius: 8px;
}

.AnimatedBackgroundPanel__fixed-da6601 {
  position: fixed;
  height: 100%;
  right: 0;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/AnimatedBackgroundPanel/AnimatedBackgroundPanel.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,qCAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AACF","sourcesContent":[".container {\n  width: 360px;\n  background-color: var(--addition-100);\n  overflow: hidden;\n  height: calc(100% - 16px);\n  margin: 8px 8px 8px 0;\n  border-radius: 8px;\n}\n\n.fixed {\n  position: fixed;\n  height: 100%;\n  right: 0;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AnimatedBackgroundPanel__container-ecfd0a`,
	"fixed": `AnimatedBackgroundPanel__fixed-da6601`
};
module.exports = ___CSS_LOADER_EXPORT___;
